import u from "./index281.js";
import { resolveComponent as m, createElementBlock as n, createCommentVNode as d, openBlock as r, createElementVNode as l, createVNode as i, Fragment as c, renderList as f, toDisplayString as s } from "vue";
import g from "./index231.js";
const h = ["data-component"], v = { class: "relative flex" }, b = ["value", "selected"], k = { class: "mr-8 font-bold group-hover:text-color-neutral-grey-60" };
function y(e, o, C, _, $, x) {
  const a = m("ms-chevron");
  return e.options && e.options.length ? (r(), n("label", {
    key: 0,
    "data-component": e.$options.name,
    class: "flex items-center cursor-pointer text-text-l group h-52"
  }, [
    l("span", v, [
      l("select", {
        class: "absolute left-0 w-full h-full font-bold opacity-0 cursor-pointer text-text-l",
        onChange: o[0] || (o[0] = (...t) => e.onChange && e.onChange(...t))
      }, [
        (r(!0), n(c, null, f(e.options, (t, p) => (r(), n("option", {
          key: t.value + p,
          value: t.value,
          selected: t.value === e.modelValue
        }, s(t.label), 9, b))), 128))
      ], 32),
      o[1] || (o[1] = l("span", {
        class: "mr-8",
        for: "select-1"
      }, "Sortierung:", -1)),
      l("span", k, s(e.label), 1),
      o[2] || (o[2] = l("span", { class: "w-1 mr-4 rounded-full bg-color-neutral-grey-10" }, null, -1)),
      i(a, { class: "inline-block h-lh-text-l-desktop w-lh-text-l-desktop" })
    ])
  ], 8, h)) : d("", !0);
}
const S = /* @__PURE__ */ g(u, [["render", y]]);
export {
  S as default
};
